import { createFileRoute, redirect } from '@tanstack/react-router'
import { ReportGenerationPage } from 'pages/reporting/ReportGenerationPage'
import { ReportRedirectPage } from 'pages/reporting/ReportRedirectPage'
import { FC } from 'react'
import {
  reportingReportSearchParams,
  SEARCH_PARAM_REPORT_ID,
} from 'routes/reporting/-searchParams'
import { Route as BaseReportingRoute } from 'routes/reporting/index'

const ReportRouteComponent: FC = () => {
  const { metadataEntryId, reportId, siteId, templateId } = Route.useSearch()

  if (!templateId) {
    return (
      <ReportRedirectPage
        reportId={reportId}
        requestedMetadataEntryId={metadataEntryId}
        siteId={siteId}
      />
    )
  }

  return (
    <ReportGenerationPage
      reportId={reportId}
      requestedMetadataEntryId={metadataEntryId}
      siteId={siteId}
      templateId={templateId}
    />
  )
}

export const Route = createFileRoute('/reporting/details')({
  component: ReportRouteComponent,
  beforeLoad: ({ search }) => {
    if (!search[SEARCH_PARAM_REPORT_ID]) {
      throw redirect({
        to: BaseReportingRoute.to,
      })
    }
  },
  staticData: {
    title: 'Report',
    layout: {
      enableScrolling: true,
    },
  },
  validateSearch: reportingReportSearchParams,
})
